<template>
  <div class="dialog-wrap">
    <el-dialog
      title="积分任务添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="任务名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="任务编码" prop="code">
          <el-input v-model="dataForm.code" placeholder="请输入任务编码（相同编码为同一任务组）"></el-input>
        </el-form-item>
        <el-form-item label="任务积分" prop="reward">
          <el-input v-model="dataForm.reward" placeholder="请输入任务积分（数值）"></el-input>
        </el-form-item>
        <el-form-item label="单日上限" prop="day_times">
          <el-input v-model="dataForm.day_times" placeholder="请输入单日最大可操作次数（数值）"></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="type">
          <el-select v-model="dataForm.type" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pointsTaskCreate } from '@/api/operation'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      types: [
        {label: '奖励', value: 1},
        {label: '消耗', value: 2}
      ],
      rules: {
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入任务编码', trigger: 'blur' }],
        reward: [{ required: true, message: '请输入任务积分', trigger: 'blur' }],
        day_times: [{ required: true, message: '请输入单日最大可操作次数', trigger: 'blur' }],
        type: [{ required: true, message: '请选择任务类型', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm)
          pointsTaskCreate(params).then(res => {
            this.$message.success(`添加成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;
    }
  }
</style>
